import React from 'react';

import View from './view';

const Component = ({ props }) => {
  return <View id={props._id} />;
};

export default Component;
